"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "Image",
  settings: _variables.ImageVariable.settings
}, {
  title: "Display",
  settings: {
    layout: {
      type: "select",
      title: "Item Style",
      description: "Name of the style to display the image with.",
      enum: ["normal", "card", "mini"],
      default: "normal"
    }
  }
}];
class ImageBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "image");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "imageVariable", void 0);
    (0, _defineProperty2.default)(this, "layoutVariable", void 0);
    this.param = param;
    this.imageVariable = this.addBlockVariable(variableTypes.get("image"), param, ["uri"]);
    this.layoutVariable = this.addBlockVariable(variableTypes.get("literal"), param, [["layout", "value"]]);
  }
  renderValue() {
    return {
      src: _variables.vals.stringValue(this.imageVariable.value()),
      layout: _variables.vals.stringValue(this.layoutVariable.value()) || "normal"
    };
  }
}
exports.ImageBlock = ImageBlock;
(0, _defineProperty2.default)(ImageBlock, "settings", settings);
(0, _defineProperty2.default)(ImageBlock, "primarySetting", "uri");
//# sourceMappingURL=ImageBlock.js.map